import { render } from "./product-list-item.vue?vue&type=template&id=1dfab4f7"
import script from "./product-list-item.vue?vue&type=script&lang=js"
export * from "./product-list-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__